var loadTrustedBySlider = function loadTrustedBySlider() {
  var slider = document.querySelector(".about-trusted-by__wrapper .splide");
  if (slider) {
    var splide = new Splide(slider, {
      arrows: false,
      pagination: false,
      type: "slide",
      perPage: 4.3,
      gap: 23,
      focus: 0,
      breakpoints: {
        700: {
          perPage: 3.2
        },
        600: {
          perPage: 1.6
        }
      }
    });
    splide.mount();
  }
};
loadTrustedBySlider();